import { DocumentTypesResponseDto } from '../../repositories/dto/res/DocumentTypesResponseDto';
import { DocumentList, DocumentType } from '@/features/section-2/application/domain/entities/DocumentType';

export function mapDocumentTypesDtoToEntity(dto: DocumentTypesResponseDto): DocumentList[] {
  if (!Array.isArray(dto)) {
    return [];
  }
  return dto.map((list) => ({
    type: list.list as DocumentType,
    documents: list.docs.map((doc) => ({
      value: doc.value,
      label: doc.label,
      imageLinks: doc.imageLinks,
    })),
  }));
}
